import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { StyledButton } from "../../../components/Button/button";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getStorageArea } from "../../../services/storage-area/get";
import {
  GetStorageAreaPayload,
  GetStorageAreas,
  StorageAreaPackages,
} from "../../../services/storage-area/get/types";
import { LoadingBackDrop } from "../../../components/loader";
import { theme } from "../../../helpers/theme";
import { Button, Divider } from "@mui/material";
import { Summary } from "../operator-orders-details/components/Summary";
import { setTemperatureConditionEnum } from "../../common-views/offer-form-summary/components/submit-an-inquiry-button/helpers";
import {
  getFiscalBreakdownEnum,
  getLengthUnitEnum,
  getPackageTypeEnum,
  getPlaceEnum,
  getStorageType,
  getTemperatureConditionsEnum,
  getWeightUnitEnum,
} from "./helpers";
import { GoBackButton } from "../../../components/GoBackButton";
import { GridColDef } from "@mui/x-data-grid";
import { StyledTable } from "../../../components/table/styled-table";
import { StyledDialog } from "../../../components/dialog/dialog";
import { settings } from "../../../helpers/toast.settings";
import { toast } from "react-toastify";
import { deleteStorageArea } from "../../../services/storage-area/delete";
import { deletePackage } from "../../../services/packages/delete";

const SubcontractorsStorageArea = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [openStorageAreaDialog, setOpenStorageAreaDialog] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState<string>("");
  const [openPackageDialog, setOpenPackageDialog] = useState(false);
  const [deletePackageRowId, setDeletePackageRowId] = useState<string>("");
  const [storageArea, setStorageArea] = useState<GetStorageAreaPayload>();

  const StorageAreaGetMutation = useQuery(
    ["StorageArea"],
    () => getStorageArea(id),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setStorageArea(data.data.payload);
      },
    }
  );
  const DeleteStorageAreaMutation = useMutation(deleteStorageArea, {
    onSuccess: () => {
      StorageAreaGetMutation.refetch();
      toast.success("Usunięto pomyślnie!", {
        toastId: "StorageAreaDeleteSuccessfully",
        ...settings,
      });
    },
  });
  const DeletePackageMutation = useMutation(deletePackage, {
    onSuccess: () => {
      StorageAreaGetMutation.refetch();
      toast.success("Usunięto pomyślnie!", {
        toastId: "PackageDeleteSuccessfully",
        ...settings,
      });
    },
  });
  const storageAreaColumns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 170,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            style={{
              marginRight: "10px",
              backgroundColor: "orange",
            }}
            onClick={() => {
              return navigate(
                `/operator/subcontractors/package/edit/${params.id}`
              );
            }}
          >
            Edytuj
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "red",
            }}
            onClick={() => {
              setOpenPackageDialog(true);
              setDeletePackageRowId(params.row.id);
            }}
          >
            Usuń
          </Button>
          <StyledDialog
            open={openPackageDialog}
            setOpen={setOpenPackageDialog}
            confirmFunction={() =>
              DeletePackageMutation.mutate({
                id_opakowanie: deletePackageRowId,
              })
            }
            dialogContent="Czy na pewno chcesz usunąć opakowanie?"
          />
        </>
      ),
    },
    {
      field: "packageType",
      headerName: "Rodzaj opakowania",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "length",
      headerName: "Długość",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "lengthMin",
      headerName: "Min",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "lengthMax",
      headerName: "Max",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "width",
      headerName: "Szerokość",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "widthMin",
      headerName: "Min",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "widthMax",
      headerName: "Max",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "height",
      headerName: "Wysokość",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "heightMin",
      headerName: "Min",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "heightMax",
      headerName: "Max",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "weight",
      headerName: "Waga",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "weightMin",
      headerName: "Min",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "weightMax",
      headerName: "Max",
      minWidth: 100,
      flex: 1,
    },
  ];
  const getRowsToStorageAreaTable = (index: number) => {
    const rows: any = storageArea?.obszary_skladowania[index].opakowania.map(
      (r: StorageAreaPackages) => ({
        id: r.id_opakowanie,
        packageType: getPackageTypeEnum(r.rodzaj_opakowania),
        length: `${
          r.dlugosc ? r.dlugosc + getLengthUnitEnum(r.jednostka_dlugosci) : "-"
        }`,
        lengthMin: `${
          r.dlugosc_min
            ? r.dlugosc_min + getLengthUnitEnum(r.jednostka_dlugosci)
            : "-"
        }`,
        lengthMax: `${
          r.dlugosc_max
            ? r.dlugosc_max + getLengthUnitEnum(r.jednostka_dlugosci)
            : "-"
        }`,
        width: `${
          r.szerokosc
            ? r.szerokosc + getLengthUnitEnum(r.jednostka_dlugosci)
            : "-"
        }`,
        widthMin: `${
          r.szerokosc_min
            ? r.szerokosc_min + getLengthUnitEnum(r.jednostka_dlugosci)
            : "-"
        }`,
        widthMax: `${
          r.szerokosc_max
            ? r.szerokosc_max + getLengthUnitEnum(r.jednostka_dlugosci)
            : "-"
        }`,
        height: `${
          r.wysokosc
            ? r.wysokosc + getLengthUnitEnum(r.jednostka_dlugosci)
            : "-"
        }`,
        heightMin: `${
          r.wysokosc_min
            ? r.wysokosc_min + getLengthUnitEnum(r.jednostka_dlugosci)
            : "-"
        }`,
        heightMax: `${
          r.wysokosc_max
            ? r.wysokosc_max + getLengthUnitEnum(r.jednostka_dlugosci)
            : "-"
        }`,
        weight: `${
          r.waga ? r.waga + getWeightUnitEnum(r.jednostka_wagi) : "-"
        }`,
        weightMin: `${
          r.waga_min ? r.waga_min + getWeightUnitEnum(r.jednostka_wagi) : "-"
        }`,
        weightMax: `${
          r.waga_max ? r.waga_max + getWeightUnitEnum(r.jednostka_wagi) : "-"
        }`,
      })
    );

    if (rows) return rows;
  };

  if (StorageAreaGetMutation.isLoading || StorageAreaGetMutation.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <StorageAreaContainer>
      <NavButtonsWrapper>
        <GoBackButton description={"Powrót"} />
        <StyledButton
          style={{ width: "120px" }}
          onClick={() =>
            navigate(
              `/operator/subcontractors/storage-area-availability/${storageArea?.id_magazyn}`
            )
          }
        >
          Dostępność
        </StyledButton>
        <StyledButton
          style={{ width: "220px" }}
          onClick={() =>
            navigate(
              `/operator/subcontractors/storage-area/add/${storageArea?.id_magazyn}`
            )
          }
        >
          Dodaj obszar składowania
        </StyledButton>
      </NavButtonsWrapper>
      {storageArea?.obszary_skladowania.map((item: GetStorageAreas, index) => (
        <>
          <SectionsDivider />
          <StorageWithPackagesWrapper>
            <StorageAreaSection>
              <SectionHeaderWrapper>
                <SectionTitle>{`Obszary składowania: ${storageArea?.kod_magazynu}`}</SectionTitle>

                <ActionButtonsWrapper>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: theme.colors.blue01_active,
                    }}
                    onClick={() =>
                      navigate(
                        `/operator/subcontractors/package/add/${item.id_obszar_skladowania}`
                      )
                    }
                  >
                    Dodaj obsługiwany obiekt
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "orange",
                    }}
                    onClick={() =>
                      navigate(
                        `/operator/subcontractors/storage-area/edit/${storageArea?.id_magazyn}/${item.id_obszar_skladowania}`
                      )
                    }
                  >
                    Edytuj
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "red",
                    }}
                    onClick={() => {
                      setOpenStorageAreaDialog(true);
                      setDeleteRowId(item.id_obszar_skladowania);
                    }}
                  >
                    Usuń
                  </Button>
                </ActionButtonsWrapper>

                <StyledDialog
                  open={openStorageAreaDialog}
                  setOpen={setOpenStorageAreaDialog}
                  confirmFunction={() =>
                    DeleteStorageAreaMutation.mutate({
                      id_obszar_skladowania: deleteRowId,
                    })
                  }
                  dialogContent="Czy na pewno chcesz usunąć obszar?"
                />
              </SectionHeaderWrapper>

              <Divider sx={{ marginBottom: "26px" }} />
              <SummaryTableContainer>
                <Summary
                  data={[
                    {
                      propertyKey: item.kod,
                      propertyName: "Kod",
                      propertyValue: item.kod,
                    },
                    {
                      propertyKey: getStorageType(item.typ_skladowania),
                      propertyName: "Typ składowania",
                      propertyValue: getStorageType(item.typ_skladowania),
                    },
                    {
                      propertyKey: getPlaceEnum(item.miejsce),
                      propertyName: "Miejsce",
                      propertyValue: getPlaceEnum(item.miejsce),
                    },
                    {
                      propertyKey: getFiscalBreakdownEnum(
                        item.podzial_fiskalny
                      ),
                      propertyName: "Podział fiskalny",
                      propertyValue: getFiscalBreakdownEnum(
                        item.podzial_fiskalny
                      ),
                    },
                    {
                      propertyKey: getTemperatureConditionsEnum(
                        item.warunek_temperaturowy
                      ),
                      propertyName: "Warunek temp.",
                      propertyValue: getTemperatureConditionsEnum(
                        item.warunek_temperaturowy
                      ),
                    },
                  ]}
                />
              </SummaryTableContainer>
            </StorageAreaSection>
            {item.opakowania.length > 0 && (
              <StorageAreaTableContianer>
                <StyledTable
                  disableExtendRowFullWidth={true}
                  rows={getRowsToStorageAreaTable(index)}
                  columns={storageAreaColumns}
                  pageSize={item.opakowania.length}
                  disableSelectionOnClick={true}
                  autoHeight
                />
              </StorageAreaTableContianer>
            )}
          </StorageWithPackagesWrapper>
        </>
      ))}
    </StorageAreaContainer>
  );
};

export default SubcontractorsStorageArea;

const StorageAreaContainer = styled.div`
  @media (min-width: 1024px) {
    margin-left: 320px;
    margin-right: 30px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-left: 20px;
    margin-right: 20px;
  }
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const StorageAreaSection = styled.section`
  background: ${theme.colors.white};
  max-width: 800px;

  border-radius: 8px;
  padding: 32px;
  margin-bottom: 20px;
  @media (max-width: 500px) {
    padding: 20px 30px;
  }
`;
const StorageWithPackagesWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const StorageAreaTableContianer = styled.div`
 width: 100%;
 display: flex;
 justify-content: center;
 margin 20px 0;
`;
const ActionButtonsWrapper = styled.div`
  margin-bottom: 14px;
  gap: 8px;
  display: flex;
`;
const SectionTitle = styled.div`
  font-family: ${theme.fonts.interRegular} !important;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: black;
  font-family: "Inter";
  color: ${theme.colors.black_primaryText};
  @media (max-width: 500px) {
    margin-top: 16px;
  }
`;
const SectionHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;
const SummaryTableContainer = styled.div`
  display: flex;
  gap: 30px;
`;
const NavButtonsWrapper = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
  width: 100%;

  //max-width: 800px;
`;
const SectionsDivider = styled.hr`
  width: 100%;
  height: 0.2px;
  margin-bottom: 30px;
  background-color: black;
`;
